import {
  type DivisionEndOfMonthRequest,
  EndMonthExportType,
  type UpdateEmployeeEndOfMonthCommentQuery,
  type ValidateEmployeeLeaveOfMonthQuery,
  type ValidateListEmployeesEndOfMonthQuery,
} from '../types/api/payload/endMonth';
import type {
  EndOfMonthHistoryResponse,
  EndOfMonthValidationResponse,
  OpenpayeUserResponse,
} from '../types/api/response/endMonth';
import { MS_ENDMONTH_ENDPOINT } from '../variables/GlobalVariables';
import request from './AxiosClient';

function getEndOfMonthValidation(
  companyId: string,
  payload: DivisionEndOfMonthRequest
): Promise<EndOfMonthValidationResponse[]> {
  return request
    .post<EndOfMonthHistoryResponse>(
      `${MS_ENDMONTH_ENDPOINT}/v2/end-month/${companyId}/history`,
      payload
    )
    .then((res) => res?.data?.validations);
}

function validateUserLeaveRequest(
  companyId: string,
  payload: ValidateEmployeeLeaveOfMonthQuery
): Promise<EndOfMonthValidationResponse> {
  return request
    .post(
      `${MS_ENDMONTH_ENDPOINT}/v2/end-month/${companyId}/validate-employee-leave-of-month`,
      payload
    )
    .then((res) => res?.data);
}

function updateEmployeeComment(
  companyId: string,
  payload: UpdateEmployeeEndOfMonthCommentQuery
): Promise<EndOfMonthValidationResponse> {
  return request
    .patch(
      `${MS_ENDMONTH_ENDPOINT}/v2/end-month/${companyId}/employee/comment`,
      payload
    )
    .then((res) => res?.data);
}

function validateEmployeesEndOfMonth(
  companyId: string,
  payload: ValidateListEmployeesEndOfMonthQuery
): Promise<EndOfMonthValidationResponse> {
  return request
    .post(
      `${MS_ENDMONTH_ENDPOINT}/v2/end-month/${companyId}/validate-list-employees-end-of-month`,
      payload
    )
    .then((res) => res?.data);
}

function getEndOfMonthExport(
  targetCompanyId: string,
  accountantCompanyId: string,
  type: EndMonthExportType,
  payload: DivisionEndOfMonthRequest
): Promise<any> {
  return request
    .post(
      `${MS_ENDMONTH_ENDPOINT}/v2/end-month/export/${targetCompanyId}/${accountantCompanyId}/type/${type}`,
      payload,
      {
        responseType: 'blob',
      }
    )
    .then((res) => res?.data);
}

function validateDivisionEndOfMonth(
  companyId: string,
  endOfMonthId: string
): Promise<EndOfMonthValidationResponse> {
  return request
    .post(
      `${MS_ENDMONTH_ENDPOINT}/v2/end-month/${companyId}/validate-division-end-of-month/${endOfMonthId}`
    )
    .then((res) => res?.data);
}

function getSynchroOpenpaye(
  companyId: string
): Promise<OpenpayeUserResponse[]> {
  return request
    .get(
      `${MS_ENDMONTH_ENDPOINT}/v2/end-month/module/openpaye/${companyId}/employee`
    )
    .then((res) => res?.data);
}

function synchroOpenpayeVariablePayroll(companyId: string): Promise<void> {
  return request
    .post(
      `${MS_ENDMONTH_ENDPOINT}/v2/end-month/module/openpaye/${companyId}/variable-payroll`
    )
    .then((res) => res?.data);
}

function synchroOpenpayePayslips(
  accountantCompanyId: string,
  targetCompanyId: string,
  month: number,
  year: number
) {
  return request
    .get(
      `${MS_ENDMONTH_ENDPOINT}/v2/end-month/module/openpaye/payslips/${targetCompanyId}/${accountantCompanyId}/${month}/${year}`
    )
    .then((res) => res?.data);
}

function createClientCompanyFromOpenpayeDossier(
  accountantCompanyId: string,
  dossierId: string
): Promise<OpenpayeUserResponse[]> {
  return request
    .post(
      `${MS_ENDMONTH_ENDPOINT}/v2/end-month/module/openpaye/${accountantCompanyId}/client?dossierId=${dossierId}`
    )
    .then((res) => res?.data);
}

function synchroOpenpayeDossierEmployeesToExistingClientCompany(
  accountantCompanyId: string,
  clientCompanyId: string,
  dossierId: string
): Promise<OpenpayeUserResponse[]> {
  return request
    .post(
      `${MS_ENDMONTH_ENDPOINT}/v2/end-month/module/openpaye/${accountantCompanyId}/client/${clientCompanyId}?dossierId=${dossierId}`
    )
    .then((res) => res?.data);
}

const EndOfMonthService = {
  getEndOfMonthValidation,
  validateUserLeaveRequest,
  updateEmployeeComment,
  validateEmployeesEndOfMonth,
  getEndOfMonthExport,
  validateDivisionEndOfMonth,
  getSynchroOpenpaye,
  synchroOpenpayeVariablePayroll,
  synchroOpenpayePayslips,
  createClientCompanyFromOpenpayeDossier,
  synchroOpenpayeDossierEmployeesToExistingClientCompany,
};

export default EndOfMonthService;
